import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


// 公共路由
export const constantRoutes = [

  {
    path: '/',
    component: () => import('@/views/cover'),
    meta:{type:1}
  },

  {
    path: '/home',
    component: () => import('@/views/home'),
    meta:{type:2}
  },
  {
    path: '/time',
    component: () => import('@/views/time'),
    meta:{type:3}
  },
  {
    path: '/detail',
    component: () => import('@/views/detail'),
    meta:{type:4}
  },
]


const originalPush =Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'hash', // 
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
